import { render, staticRenderFns } from "./smsRecordTable.vue?vue&type=template&id=6fbbd361&scoped=true"
import script from "./smsRecordTable.vue?vue&type=script&lang=js"
export * from "./smsRecordTable.vue?vue&type=script&lang=js"
import style0 from "./smsRecordTable.vue?vue&type=style&index=0&id=6fbbd361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbd361",
  null
  
)

export default component.exports